import { render, staticRenderFns } from "./ConsentimientosForm.vue?vue&type=template&id=73146ee2"
import script from "./ConsentimientosForm.vue?vue&type=script&lang=js"
export * from "./ConsentimientosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports